import React from 'react';
import enhanceWithClickOutside from 'react-click-outside';
import { jsx as ___EmotionJSX } from "@emotion/core";
class ClickOutsideBase extends React.Component {
  constructor(props) {
    super(props);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }
  handleClickOutside() {
    var _this$props$onClickOu, _this$props;
    (_this$props$onClickOu = (_this$props = this.props).onClickOutside) === null || _this$props$onClickOu === void 0 ? void 0 : _this$props$onClickOu.call(_this$props);
  }
  render() {
    return ___EmotionJSX("div", null, this.props.children);
  }
}
var ClickOutside = enhanceWithClickOutside(ClickOutsideBase);
export default ClickOutside;